export default __webpack_public_path__ + "static/media/Mymap.f10eddd5.png";